import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Directions from '@material-ui/icons/Directions';

const DestinationListItem = (props) => {
    const { 
        destination, 
        onDestinationClick 
    } = props;

    const onDestinationClickHandler = () => {
        onDestinationClick(destination);
    };

    return (
        <ListItem button onClick={onDestinationClickHandler}>
            <ListItemAvatar>
                <Avatar>
                    <Directions />
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={destination} />
        </ListItem>
    );
}

export default DestinationListItem;